export { default as PrimaryHeading } from './PrimaryHeading';
export { default as SecondaryHeading } from './SecondaryHeading';
export { default as TertiaryHeading } from './TertiaryHeading';
export { default as BodyBoldUppercase } from './BodyBoldUppercase';
